export const ChargebackPreventionOrderStatusEnum = {
  Accepted: 'accepted',
  Timeout: 'timeout',
  Invalid: 'invalid',
  NotFound: 'not_found',
  Failed: 'failed',
};

export const ChargebackPreventionOrderPaymentTypeEnum = {
  Mastercard: 'masterCard',
  Visa: 'visa',
  AmericanExpress: 'americanExpress',
  Discover: 'discover',
  Other: 'other',
};

export const ChargebackPreventionOrderStatus = [
  { title: 'Accepted', value: ChargebackPreventionOrderStatusEnum.Accepted },
  { title: 'Timeout', value: ChargebackPreventionOrderStatusEnum.Timeout },
  { title: 'Invalid', value: ChargebackPreventionOrderStatusEnum.Invalid },
  { title: 'Not Found', value: ChargebackPreventionOrderStatusEnum.NotFound },
  { title: 'Failed', value: ChargebackPreventionOrderStatusEnum.Failed },
];

export const ChargebackPreventionOrderPaymentType = [
  { title: 'Mastercard', value: ChargebackPreventionOrderPaymentTypeEnum.Mastercard },
  { title: 'Visa', value: ChargebackPreventionOrderPaymentTypeEnum.Visa },
  { title: 'American Express', value: ChargebackPreventionOrderPaymentTypeEnum.AmericanExpress },
  { title: 'Discover', value: ChargebackPreventionOrderPaymentTypeEnum.Discover },
  { title: 'Other', value: ChargebackPreventionOrderPaymentTypeEnum.Other },
];

export const ChargebackPreventionOrderServiceType = [
  { title: 'Mastercard', value: 'ethoca' },
  { title: 'Visa', value: 'verifi' },
];

export const ChargebackPreventionOrderSource = [
  { title: 'DIGITAL', value: ['ethoca_dgl'], serviceType: 'ethoca' },
  { title: 'CALL CENTRE', value: ['ethoca_cc'], serviceType: 'ethoca' },
  { title: 'FPT', value: ['ethoca_fpt'], serviceType: 'ethoca' },
  { title: 'MASTERCOM', value: ['ethoca_mastercom'], serviceType: 'ethoca' },
  { title: 'TRANSACTION DATA', value: ['ethoca_transaction_data'], serviceType: 'ethoca' },
  { title: 'OI + OID', value: ['verifi_oi', 'verifi_oid', 'verifi_oi_ce', 'verifi_oid_ce'], serviceType: 'verifi' },
  { title: 'OI/CE + OID/CE', value: ['verifi_oi_ce', 'verifi_oid_ce'], serviceType: 'verifi' },
  { title: 'CE', value: ['verifi_ce'], serviceType: 'verifi' },
];
